import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { GetRace, GetRaces, GetStartlist, ShowOnlyV75, AddBoldFont, TrimByChar, FormatV75Odds, DisplayTrackName, StartClassName } from './HelperService';

export const TheStartlist = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [races, setRaces] = useState([]);
    const [race, setRace] = useState();
    const [loading, setloading] = useState(true);

    useEffect(() => {
        // Set background theme
        document.getElementById("root").classList.add(params.theme);

        GetRaces(
            params.date, 
            params.trackId, 
            data => {
                setRaces(data.results);
                let rce = data.results.find(r => r.race_number == params.raceNumber);
                setRace(rce);
                updateStartlist(rce);
                // const intervalId = setInterval(() => {updateStartlist(data.results[0])}, 10000);
                // return () => clearInterval(intervalId);
            },
            error => {
                console.log(error);
            });
    }, [params]);

    const navPrevNext = (step) => {
        setloading(true);
        navigate(`/startlist/${params.date}/${params.trackId}/${parseInt(params.raceNumber)+step}/${params.bettype}/${params.theme}`);
    }

    function getPrevNextClassName(name) {
        let maxRaceNumber = Math.max(...races.map(o => o.race_number));
        console.log(maxRaceNumber);
        if((name == "next" && params.raceNumber >= maxRaceNumber) || (name == "back" && params.raceNumber <= 1))
            return `${name} hidden`;
        return name;
    }

    function updateStartlist(race) {
        if(race) {
            GetStartlist(
                race.id,
                list => {
                    setList(list);
                    setloading(false);
                },
                err => {
                    console.log(err);
                }
            );
        }
    }

    function renderList() {
        let currentDistance;
        return (
            <div className='startList'>
                <div className='navbar'>
                    <div className='clearfix'>
                        <div className={getPrevNextClassName("next")} onClick={() => navPrevNext(1)}>&gt;</div>
                        <div className={getPrevNextClassName("back")} onClick={() => navPrevNext(-1)}>&lt;</div>
                    </div>
                </div>
                <div className='heading clearfix'>
                    <div className='leg'>{DisplayTrackName(race, params.bettype)}</div>
                    <div className='headerWrapper'>
                        <div className='row1 clearfix'>
                            <div className='raceName'>
                                {TrimByChar(list.race_name, 100, '-')}
                            </div>
                            <div className='method'>{race.base_dist}<span className='lower'></span> {race.start_method}</div>
                        </div>
                        <div className='row2 clearfix'>
                            <div className='driverHeader'>
                                KUSK
                            </div>
                            <div className='trainerHeader'>
                                TRÄNARE
                            </div>
                            <div className={ShowOnlyV75('oddsHeader', params.bettype, race)}>
                                {params.bettype}%
                            </div>
                            <div className='distanceHeader'>
                                DISTANS
                            </div>
                        </div>
                    </div>
                </div>
                {
                list.starts.map((start, index) => {
                    let isBold = false;
                    if(currentDistance != start.distance) {
                        isBold = true;
                        currentDistance = start.distance;
                    }
                    return (
                        <div key={start.start_number} className={StartClassName(start, list.starts.length, index)}>
                            <div className='horse'>{start.start_number} {start.horse.name}</div>
                            <div className='driver'>{start.driver}</div>
                            <div className='trainer'>{start.trainer_detail.name}</div>
                            <div className={ShowOnlyV75('odds', params.bettype, race)}>{FormatV75Odds(start, false)}</div>
                            <div className={AddBoldFont('distance', isBold)}>{start.scratched ? "" : start.distance}</div>
                        </div>
                    )
                }) }
            </div>
        )
    }

    let content = loading
        ? <></>
        : renderList()

    return (
        <>
            {content}
        </>
    )
}
